import { render, staticRenderFns } from "./newEntrants.vue?vue&type=template&id=0bdbe493&scoped=true&"
import script from "./newEntrants.vue?vue&type=script&lang=js&"
export * from "./newEntrants.vue?vue&type=script&lang=js&"
import style0 from "./newEntrants.vue?vue&type=style&index=0&id=0bdbe493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbe493",
  null
  
)

export default component.exports